<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <div class="d-flex flex-column scrollable">
    <full-page-modal
      ref="tagsModal"
      ok-only
      :title="selected && selected.name"
      header-bg-variant="primary"
      header-text-variant="white"
      body-class="p-0"
      @hidden="tagsModalClosed"
      @ok="setTags"
    >
      <template v-if="selected && availableTags">
        <tag-alternatives
          :value="unsatisfiedTagAlternatives"
          class="bg-warning p-2"
        />
        <div class="padded">
          <options-form-field
            multiple
            :options="availableTags"
            :item2option="item => ({ text: item.label, value: item.id })"
            :value2id="item => item.id"
            :id2value="id => availableTags.find(item => item.id === id)"
            v-model="selected.tags"
          ></options-form-field>
        </div>
      </template>
    </full-page-modal>

    <full-page-modal
      ref="uploadModal"
      hide-footer
      title="Carica allegati"
      header-bg-variant="primary"
      header-text-variant="white"
      body-class="p-0 d-flex flex-column"
    >
      <tag-alternatives
        :value="unsatisfiedTagAlternatives"
        class="bg-warning p-2"
      />
      <!--
      v-if="!disabled"

      :custom-columns="pendingFilesCustomColumns"
      :custom-actions="pendingFilesCustomActions"
      :validate-file="validatePendingFile"


      -->
      <file-table
        class="mb-0 flex-grow-1 padded"
        ref="fileTable"
        label="Caricare qui i file, trascinandoli nel campo sottostante o utilizzando l'apposito pulsante."
        :value="pendingFiles"
        @input="pendingFiles = $event"
        @upload="upload($event)"
      >
      </file-table>
    </full-page-modal>

    <!--
    <b-button
      variant="success"
      block
      @click.prevent="$refs.uploadModal.show()">
      Upload
    </b-button>
    -->

    <data-table
      class="flex-grow-1 mb-0"
      striped
      hover
      condensed
      :stacked="isSmDown"
      :value="attachments"
      :columns="columns"
      :sortedBy="sortedBy"
      :sortOrder="sortOrder"
      @sort="sort"
    >
      <slot slot="before-results"></slot>
    </data-table>
  </div>
</template>
<script>
import TagService from "@/modules/tag/protected/TagService";
import http from "core/http/HttpService";
import {
  error2text,
  downloadBlob,
  number2fileSize,
  formatDateTime
} from "core/utils";
import findIndex from "lodash/findIndex";
import orderBy from "lodash/orderBy";
import HasFileTableMixin from "vue-template/protected/mixins/HasFileTableMixin";
import TagAlternatives from "@/protected/components/TagAlternatives";

export default {
  mixins: [HasFileTableMixin],

  components: {
    TagAlternatives
  },

  props: {
    context: {
      type: String,
      required: true
    },

    contextId: {
      type: [String, Number],
      required: true
    },

    subcontext: {
      type: String,
      required: true
    },

    permissions: {
      type: Object,
      required: true
    },

    unsatisfiedTagAlternatives: {
      type: Array,
      default: undefined
    }
  },

  data() {
    return {
      pendingFiles: [],
      attachments: [],
      selected: null,
      availableTags: [],
      sortedBy: "name",
      sortOrder: "ASC"
    };
  },

  watch: {
    context: "loadAttachments",
    contextId: "loadAttachments",
    subcontext: "loadAttachments"
  },

  computed: {
    columns() {
      return [
        {
          key: "name",
          sortBy: "name",
          label: this.$t("attachment.fields.name"),
          styleClass: "col-6 text-truncate",
          stackedStyleClass: "col-6 text-truncate",
          onClick: ({ row }) => {
            this.download(row);
          }
        },
        {
          key: "created",
          sortBy: "created",
          label: this.$t("attachment.fields.created"),
          styleClass: "col-3 text-truncate",
          stackedStyleClass: "col-6 text-truncate",
          value: ({ row }) => formatDateTime(row.created, "DD/MM/YYYY HH:mm")
        },
        {
          key: "person",
          styleClass: "col-3 text-truncate",
          stackedStyleClass: "col-6 text-truncate",
          sortBy: "person.lastName",
          label: this.$t("attachment.fields.person"),
          value: ({ row }) => {
            return row.uploadedBy.firstName + " " + row.uploadedBy.lastName;
          }
        },
        {
          key: "tags",
          label: this.$t("attachment.fields.tags"),
          styleClass: "col-6",
          stackedStyleClass: "col-6",
          type: "tags",
          value: ({ row }) => {
            return row.tags.map(t => ({
              text: t.label
            }));
          }
        },
        {
          key: "size",
          sortBy: "size",
          label: this.$t("attachment.fields.size"),
          styleClass: "col-3",
          stackedStyleClass: "col-6",
          value: ({ row }) => number2fileSize(row.size)
        },

        {
          key: "actions",
          label: this.$t("common.actions"),
          styleClass: "col-3",
          stackedStyleClass: "col-6",
          type: "actions",
          actions: [
            {
              label: this.$t("common.tags"),
              icon: "tag",
              variant: "outline-primary",
              show: this.permissions.updateTags,
              action: ({ row }) => {
                this.selected = {
                  id: row.id,
                  name: row.name,
                  tags: [...row.tags]
                };
                this.$refs.tagsModal.show();
              }
            },
            {
              label: this.$t("common.rename"),
              icon: "pen",
              variant: "outline-info",
              show: this.permissions.rename,
              action: ({ row }) => {
                const oldName = row.name;
                let newName = prompt(this.$t("common.rename"), oldName);
                if (newName) {
                  newName = newName.trim();
                  if (newName) {
                    this.rename(row, newName);
                  }
                }
              }
            },
            {
              label: this.$t("common.remove"),
              icon: "trash",
              variant: "outline-danger",
              show: this.permissions.delete,
              action: ({ row }) => {
                if (!confirm(`Vuoi veramente eliminare il file ${row.name}?`)) {
                  return;
                }
                this.remove(row);
              }
            }
          ]
        }
      ];
    }
  },

  async mounted() {
    await this.loadTags();
    this.loadAttachments();
  },

  /*
  beforeUpdate() {
    this.loadAttachments();
  },
  */

  methods: {
    async loadTags() {
      try {
        const { data } = await TagService.find();
        const page = data;
        this.availableTags = page.content;
      } catch (e) {
        console.error("Error loading tags", e);
      }
    },

    tagsModalClosed() {
      this.selected = null;
    },

    tagsSelected(tags) {
      console.log("Selected tags: ", tags);
    },

    setTags(e) {
      e.preventDefault();

      const success = ({ statusCode, data }) => {
        console.log("Tags correctly updated:", statusCode, data);
        this.$refs.tagsModal.hide();
      };

      const error = ({ statusCode, data }) => {
        console.log("Tags update error:", statusCode, data);
        alert(error2text(data));
      };

      const attachment = this.selected;

      let url =
        this.$env.baseUrl +
        "/" +
        this.context +
        "/" +
        this.contextId +
        "/attachments/" +
        this.subcontext;

      /*
      if (this.externalContext && this.externalContextId) {
        url += '/ext/' + this.externalContext
            + '/' + this.externalContextId;
      }
      */

      url += "/" + attachment.id + "/tags/" + attachment.name;

      http
        .put({
          url,
          data: attachment.tags
        })
        .then(success, error);
    },

    rename(attachment, newName) {
      const success = ({ statusCode, data }) => {
        console.log("Attachment correctly renamed:", statusCode, data);
        //this.$refs.tagsModal.hide();
      };

      const error = ({ statusCode, data }) => {
        console.log("Rename error:", statusCode, data);
        alert(error2text(data));
      };

      let url =
        this.$env.baseUrl +
        "/" +
        this.context +
        "/" +
        this.contextId +
        "/attachments/" +
        this.subcontext;

      /*
      if (this.externalContext && this.externalContextId) {
        url += '/ext/' + this.externalContext
            + '/' + this.externalContextId;
      }
      */

      url += "/" + attachment.id + "/rename/" + attachment.name;

      http
        .put({
          url,
          contentType: "text/plain; charset=UTF-8",
          data: newName
        })
        .then(success, error);
    },

    remove(attachment) {
      const success = ({ statusCode, data }) => {
        console.log("Attachment correctly removed:", statusCode, data);
      };

      const error = ({ statusCode, data }) => {
        console.log("Remove error:", statusCode, data);
        alert(error2text(data));
      };

      let url =
        this.$env.baseUrl +
        "/" +
        this.context +
        "/" +
        this.contextId +
        "/attachments/" +
        this.subcontext;

      /*
      if (this.externalContext && this.externalContextId) {
        url += '/ext/' + this.externalContext
            + '/' + this.externalContextId;
      }
      */

      url += "/" + attachment.id + "/" + attachment.name;

      http
        .delete({
          url
        })
        .then(success, error);
    },

    // =========================================================================

    loadAttachments() {
      const success = ({ statusCode, data }) => {
        console.log("Attachments correctly loaded:", statusCode, data);
        this.attachments = data;
        this.sort();
      };

      const error = ({ statusCode, data }) => {
        console.log("Attachments loading error:", statusCode, data);
        alert(error2text(data));
      };

      let url =
        this.$env.baseUrl +
        "/" +
        this.context +
        "/" +
        this.contextId +
        "/attachments/" +
        this.subcontext;

      /*
      if (this.externalContext && this.externalContextId) {
        url += '/ext/' + this.externalContext
            + '/' + this.externalContextId;
      }
      */

      http
        .get({
          url
        })
        .then(success, error);
    },

    // =========================================================================

    exportAttachments() {
      const filename = "attachments.zip";

      const success = ({ statusCode, data }) => {
        console.log("Attachments correctly loaded:", statusCode, data);
        downloadBlob(data, filename);
      };

      const error = ({ statusCode, data }) => {
        console.log("Attachments loading error:", statusCode, data);
        alert(error2text(data));
      };

      let url =
        this.$env.baseUrl +
        "/" +
        this.context +
        "/" +
        this.contextId +
        "/attachments/" +
        this.subcontext;

      /*
      if (this.externalContext && this.externalContextId) {
        url += '/ext/' + this.externalContext
            + '/' + this.externalContextId;
      }
      */

      url += "?export=ZIP";

      http
        .get({
          url,
          blob: true
        })
        .then(success, error);
    },

    // =========================================================================

    download(attachment) {
      const filename = attachment.name;

      const success = ({ statusCode, data }) => {
        console.log("Download success:", statusCode, data);
        downloadBlob(data, filename);
      };

      const error = ({ statusCode, data }) => {
        console.log("Download error:", statusCode, data);
        alert(error2text(data));
      };

      let url =
        this.$env.baseUrl +
        "/" +
        this.context +
        "/" +
        this.contextId +
        "/attachments/" +
        this.subcontext;

      /*
      if (this.externalContext && this.externalContextId) {
        url += '/ext/' + this.externalContext
            + '/' + this.externalContextId;
      }
      */

      url += "/" + attachment.id + "/" + attachment.name;

      http
        .get({
          url,
          blob: true
        })
        .then(success, error);

      return false;
    },

    // =========================================================================

    getUploadUrl(f) {
      let url =
        this.$env.baseUrl +
        "/" +
        this.context +
        "/" +
        this.contextId +
        "/attachments/" +
        this.subcontext;

      /*
      if (this.externalContext && this.externalContextId) {
        url += '/ext/' + this.externalContext
            + '/' + this.externalContextId;
      }
      */

      url += "/" + encodeURIComponent(f.name);

      return url;
    },

    uploadCompleted() {
      this.sort();
    },

    // =========================================================================

    /*
    showModal() {
      this.$refs.uploadModal.show();
    },

    setProgress(file, loaded, total) {
      this.$refs.fileTable.setProgress(file, loaded, total);
    },

    setFileError(file, error) {
      this.$refs.fileTable.setError(file, error);
    },

    upload(files) {
      const promises = [];
      const uploaded = {};

      for (let f of files) {
        const progress = (loaded, total) => {
          this.setProgress(f, loaded, total);
        }

        const success = ({ data }) => {
          this.setProgress(f, f.size, f.size);
          uploaded[f.id] = data;
          return Promise.resolve(true);
        }

        const error = ({ data }) => {
          this.setFileError(f, data);
          return Promise.reject(false);
        }

        this.loading = true;

        let url = this.$env.baseUrl
            + '/' + this.context
            + '/' + this.contextId
            + '/attachments/' + this.subcontext;

        if (this.externalContext && this.externalContextId) {
          url += '/ext/' + this.externalContext
              + '/' + this.externalContextId;
        }

        url += '/' + encodeURIComponent(f.name);

        const prom = http.upload({
          url,
          data: f,
          progress
        }).then(success, error);

        promises.push(prom);
      }

      const completedSuccess = () => {
        this.loading = false;
        this.sort();
        this.pendingFiles = [];
        this.$refs.uploadModal.hide();
      };

      const completedError = () => {
        this.loading = false;
        this.sort();
      };

      Promise.all(promises).then(completedSuccess, completedError);
    },
    */

    // =========================================================================

    addAttachment(attachment) {
      console.log("Add attachment", attachment);
      this.attachments.push(attachment);
      this.sort();
    },

    replaceAttachment(attachment) {
      const index = findIndex(this.attachments, a => a.id === attachment.id);
      const newAttachments = [...this.attachments];
      newAttachments[index] = attachment;
      this.attachments = newAttachments;
      this.sort();
    },

    removeAttachment(attachment) {
      this.attachments = this.attachments.filter(a => a.id !== attachment.id);
      this.sort();
    },

    // =========================================================================

    sort(sort, order) {
      if (!sort) {
        sort = this.sortedBy;
      }
      if (!order) {
        order = this.sortOrder;
      }
      //console.log('sortBy(', sort, ',', order, ')');
      //console.log('attachments', [ ...this.attachments ]);
      const sorted = orderBy(this.attachments, [sort], [order.toLowerCase()]);
      //console.log('sorted', sorted);
      this.attachments = sorted;
      this.sortedBy = sort;
      this.sortOrder = order;
    }
  }
};
</script>
